<template>
    <input type="hidden" name="_token" :value="csrf">
</template>

<script>

export default {

    data() {
        return {
            csrf: window.csrf,
        };
    },

};

</script>



// WEBPACK FOOTER //
// resources/js/components/elements/csrf.vue